<template lang="pug">
  div(v-if="user")
    video.video(
      v-if="user.cameraFlag"
      :srcObject.prop="stream",
      :id="`video${stream.peerId}`",
      autoplay,
      muted,
      playsinline,
      :style="user.shareFlag ? localLayoutCover : layoutCover",
      @click="changeMainStream"
    )
    .video(
      v-else
      @click="changeMainStream"
    )
      .video__wrapper-user
        .video__user-icon
          img.video__user-img(:src="user.icon || '/static/img/app/user-icon.svg'")
        .video__user-name(
          v-show="!layoutSubFlag",
          :class="{ 'video__user-name--small': layoutSubFlag }"
        )
          | {{ user.name }}
    audio.d-none(
      v-if="user.micFlag"
      :srcObject.prop="stream",
      :id="`a-${stream.peerId}`",
      autoplay
    )
    .video-wrapper__user.video-wrapper__user--other
      .video-wrapper__user-name
        | {{ user.name }}
    .video-wrapper__mic(v-if="!user.shareFlag")
      .video-wrapper__audio-level(v-if="user.micFlag")
        .video-wrapper__audio-level-item(:style="audioLevelHeight(0.6)")
        .video-wrapper__audio-level-item(:style="audioLevelHeight(1)")
        .video-wrapper__audio-level-item(:style="audioLevelHeight(0.6)")
      .video-wrapper__mic-circle(v-else)
        img.video-wrapper__mic-icon(src="/static/img/app/btn-microphone-slash.svg")
    .video-wrapper__controller(v-if="!user.shareFlag")
      button.btn-reset.video-wrapper__controller-button(
        type="button",
        data-toggle="dropdown",
        aria-haspopup="true",
        aria-expanded="false"
      )
        i.fas.fa-ellipsis-v.text-white.fsz-20
      .dropdown-menu.dropdown-menu-right.video-wrapper__controller-dropdown.fsz-14
        button.dropdown-item.px-3(
          v-if="user.cameraFlag",
          type="button",
          :data-video-id="`video${stream.peerId}`",
          @click="fullScreenMode"
        )
          i.fa.fa-expand.mr-1
          | フルスクリーン
        button.dropdown-item.px-3(
          v-if="!stealth",
          type="button",
          :data-video-id="`video${stream.peerId}`",
          @click="toggleVoice"
        )
          i.fa.fa-volume.mr-1
          | 音声ON/OFF
        button.dropdown-item.px-3(
          v-if="!stealth",
          type="button",
          @click="exit"
        )
          i.fa.fa-sign-out.mr-1
          | 退出
    .video-wrapper__layout-cover(v-if="user.shareFlag && !layoutSubFlag")
      .custom-control.custom-switch
        input#sharelocalLayoutCoverFlag.custom-control-input(
          v-model="localLayoutCoverFlag",
          type="checkbox",
          @click="changeLayout"
        )
        label.custom-control-label.text-white(for="sharelocalLayoutCoverFlag")
          | 拡大
</template>

<script>
import { getDecibel, getAudioLevelHeight } from '../../utils/audioLevel'

export default {
  name: 'OtherStream',
  props: ['stream'],
  data () {
    return {
      muteFlag: false,
      decibel: -Infinity,
      localLayoutCoverFlag: false
    }
  },
  computed: {
    layoutCover () {
      return this.$store.getters.layoutCover
    },
    localLayoutCover () {
      // 共有画面の場合に使用
      return this.localLayoutCoverFlag ? { objectFit: 'cover' } : ''
    },
    layoutSubFlag () {
      return this.$store.getters.layoutSubFlag(this.stream.peerId)
    },
    user () {
      return this.$store.state.users[this.stream.peerId]
    },
    stealth () {
      return this.$store.state.stealth
    }
  },
  created () {
    this.updateDecibel()
  },
  watch: {
    stream () {
      this.updateDecibel()
    }
  },
  methods: {
    fullScreenMode (e) {
      // 動画をフルスクリーンへ
      const $video = document.getElementById(e.currentTarget.dataset.videoId)

      // まだrequestFullScreenが完全実装されていないためこんな分岐になってる
      if ($video.webkitSupportsFullscreen) {
        $video.webkitRequestFullscreen()
      } else if ($video.mozRequestFullScreen) {
        $video.mozRequestFullScreen()
      } else if ($video.msRequestFullscreen) {
        $video.msRequestFullscreen()
      } else if ($video.requestFullScreen) {
        $video.requestFullScreen()
      }
    },
    toggleVoice (e) {
      // 音声のON/OFF
      const payload = {
        type: 'users',
        peerId: this.stream.peerId,
        data: {
          micFlag: !this.user.micFlag
        }
      }

      // マイクフラグを共有
      this.$store.state.room.send(payload)
      this.$store.dispatch('updateUsers', { payload })
    },
    exit () {
      // 退出させる
      const payload = {
        type: 'exit',
        peerId: this.stream.peerId
      }

      this.$store.state.room.send(payload)
    },
    changeMainStream () {
      this.$emit('event-changeMainStream', this.stream.peerId)
    },
    updateDecibel () {
      const self = this
      getDecibel(this.stream, self)
    },
    audioLevelHeight (value) {
      return getAudioLevelHeight(this.decibel, value)
    },
    changeLayout () {
      this.localLayoutCoverFlag = !this.localLayoutCoverFlag
    }
  }
}
</script>
